import('../src/javascripts/modal_dialog');
import('../src/javascripts/chat-bot-form');
import('../src/javascripts/need-help-form');
